import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function initOtherSwiper() {
    const otherSwiper = document.querySelector('.other__swiper');

    if (!otherSwiper) return;

    const swiper = new Swiper(otherSwiper, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 600,
        centerInsufficientSlides: true,
        navigation: {
            nextEl: '.other .swiper-button-next',
            prevEl: '.other .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 24,
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initOtherSwiper();
})